import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.locale = window.location.pathname.split("/")[1].toUpperCase();
  }

  gtagClick(e) {
    const label = e?.params?.label || "";
    const lang = this.locale.length > 2 || !this.locale ? "EN" : this.locale;

    if (label === "appstore") {
      gtag("event", "click_download_app", {
        language: lang,
        store: "App Store",
        place: "footer"
      });
    } else if (label === "googleplay") {
      gtag("event", "click_download_app", {
        language: lang,
        store: "Google Play",
        place: "footer"
      });
    } else if (["instagram", "facebook", "youtube"].includes(label)) {
      gtag("event", "click_social", {
        language: lang,
        network: label,
        place: "footer"
      });
    } else {
      gtag("event", "navigation_click", {
        language: lang,
        place: "footer",
        menu_block: label
      });
    }
  }
}
